import React from 'react';
import { MainLayout } from 'components/layouts';
import CreateTemplateFrom from './createTemplateForm';
import { useTranslation } from 'react-i18next';
import useWelfare from '../hook/useDropdownTemplate';
import useNotificationTemplateList from '../hook/useNotificationTemplateList';
import { Breadcrumb, Flex, Space } from 'antd';


const CreateTemplatePage = () => {
    const { t } = useTranslation();
    const { onCalculateAsChange, incomeOptions } = useWelfare(); // นำเข้า props จาก useWelfare
    const { getTemplateData } = useNotificationTemplateList();
    const { onSubmit } = useNotificationTemplateList();

    return (
        <MainLayout>
            <Space size={24} direction='vertical'>
                <Flex vertical>
                    <Breadcrumb items={[
                        { title: t('home.header'), href: '/' },
                        { title: t('masterdata.header'), href: "" },
                        { title: t('notification_template.header') },
                    ]} />
                    <h2>{t('notification_template.header')}</h2>
                </Flex>
                <CreateTemplateFrom onSubmit={onSubmit} getTemplateData={getTemplateData} incomeOptions={incomeOptions} onCalculateAsChange={onCalculateAsChange} /> {/* ส่ง props ไปยัง CreagteTemplateFrom */}
            </Space>
        </MainLayout>
    );
};

export default CreateTemplatePage;
